import {
    DELETE_TALENT_MULTIPLE_SUCCESS,
    GET_TALENT_SUCCESS,
    GET_TALENTS_SUCCESS,
    PRESENTATION_TALENT_SUCCESS,
    SALARY_DETAILS_SUCCESS,
    SALARY_TAX_DETAILS_SUCCESS,
    SET_TALENT_STATE,
    UPDATE_PROFILE_STATUS_SUCCESS,
    UPDATE_SEMI_PROFILE_SUCCESS,
    UPDATE_TALENT_MULTIPLE_LEVEL_SUCCESS,
    UPDATE_TALENT_MULTIPLE_SUCCESS,
    UPDATE_TALENT_SUCCESS,
    REFETCH_TALENT,
    UPDATE_EDU_EXP_CERT_SUCCESS,
    SKILL_LANG_HOBBY,
    UPDATE_SKILL_LANG_HOBBY_SUCCESS,
    GET_TALENTS_COUNT_SUCCESS,
    GET_TALENTS_COUNT,
    GET_TALENTS_ES_SUCCESS,
    GET_TALENTS_ES_RESET,
    GET_TIMESHEETS_SUCCESS,
    UPSERT_TIMESHEETS_SUCCESS,
    GET_EXPENSE_REPORTS_SUCCESS,
    UPSERT_EXPENSE_REPORTS_SUCCESS,
    DELETE_EXPENSE_REPORTS_SUCCESS,
    GET_CONTRACTOR_INVOICE_SUCCESS,
    UPSERT_CONTRACTOR_INVOICE_SUCCESS,
    GET_HOLIDAYS_SUCCESS,
    UPSERT_HOLIDAYS_SUCCESS,
    GET_BONUS_SUCCESS, UPSERT_BONUS_SUCCESS, UPSERT_SURVEY_SUCCESS,
    GET_TALENTS_ES_RESET_PAGE,
    GET_CONTRACTOR_INVOICE_EXPLAIN_SUCCESS,
    UPSERT_CONTRACTOR_INVOICE_VALIDATION_ERROR,
    STORE_TALENT_RATING,
    UPDATE_TALENT_BANKING_SUCCESS,
    GET_TALENT_EMPLOYMENT_SUCCESS,
    GET_TALENTS_BY_IDS,
    GET_TALENTS_BY_IDS_SUCCESS,
    GET_TALENTS_BY_IDS_FAILURE,
    CHECK_BANNER_MESSAGE_SUCCESS,
    CHECK_BANNER_MESSAGE_FAILURE,
    CHECK_BANNER_MESSAGE,
    MARK_BANNER_MESSAGE_AS_READ,
    MARK_BANNER_MESSAGE_SUCCESS,
    MARK_BANNER_MESSAGE_FAILURE,
    UPDATE_SEMI_PROFILE_ERROR,
    CLEAR_SEMI_PROFILE_ERROR,
    GET_TALENT_HOLIDAYS,
    GET_TALENT_HOLIDAYS_SUCCESS,
    GET_TALENT_HOLIDAYS_FAILURE,
    GET_TALENT_PORTFOLIO,
    GET_TALENT_PORTFOLIO_SUCCESS,
    GET_TALENT_PORTFOLIO_FAILURE,
    CREATE_PORTFOLIO,
    CREATE_PORTFOLIO_SUCCESS,
    CREATE_PORTFOLIO_FAILURE,
    DELETE_PORTFOLIO,
    DELETE_PORTFOLIO_SUCCESS,
    DELETE_PORTFOLIO_FAILURE,
    UPSERT_TALENT_AVAILABILITY_SUCCESS
} from '../action-types'

const INIT_STATE = {
    talent: null,
    presentation: "",
    semi_profile: {},
    semi_profile_error: null,
    reupdate_talent: 0,
    salary_details: [],
    salary_tax_details: [],
    talents: [],
    talents_es: [],
    ratings: [],
    talents_es_total: 0,
    paginator: {
        currentPage: 1,
        lastPage: 1,
        total: 0
    },
    paginatorCount: {
        currentPage: 1,
        lastPage: 1,
        total: 0
    },
    paginatorCountLoading: false,
    changed_skill_lang_hobby: false,
    timesheets: [],
    expense_reports: [],
    contractor_invoices: [],
    contractor_invoice_single: {
        items: "[]"
    },
    holidays: [],
    bonus: [],
    survey: null,
    page_reset: 0,
    invoice_explain : [],
    validation_error_date : '',
    talent_banking: [],
    talent_employment: [],
    talentsByids: [],
    bannerMessage: null,
    talent_holidays: [],
    talent_holidays_loading: false,
    talent_holidays_error: null,
    portfolio: null,
    portfolio_loading: false,
    portfolio_error: null,
    talent_portfolio: null,
    talent_portfolio_loading: false,
    talent_portfolio_error: null,
    portfolio_create_loading: false,
    portfolio_create_error: null,
    portfolio_create_success: false,
    availability_update_count: 0,
    availability_data: null
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CHECK_BANNER_MESSAGE:
            return { ...state, loading: true };
          case CHECK_BANNER_MESSAGE_SUCCESS:
            return { ...state, loading: false, bannerMessage: action.payload.banner_messages };
          case CHECK_BANNER_MESSAGE_FAILURE:
            return { ...state, loading: false, error: action.payload };
          case MARK_BANNER_MESSAGE_AS_READ:
            return { ...state, loading: true };
          case MARK_BANNER_MESSAGE_SUCCESS:
            return { ...state, loading: false };
          case MARK_BANNER_MESSAGE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case GET_TALENTS_BY_IDS:
            return { ...state, loading: true, error: null };
        case GET_TALENTS_BY_IDS_SUCCESS:
            return { 
                ...state, 
                loading: false, 
                talentsByids: action.payload
            };
        case GET_TALENTS_BY_IDS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case GET_TALENT_SUCCESS: {
            return {...state, talent: action?.data?.talentById}
        }

        case GET_TALENTS_SUCCESS: {
            return {...state, talents: action?.data?.talents, paginator: action?.data?.talents?.paginatorInfo, paginatorCount: action?.data?.talents?.paginatorInfo}
        }

        case GET_TALENTS_ES_SUCCESS: {
            return {...state, talents_es: action?.data, paginator: action?.paginator , paginatorCount: action?.paginatorCount, talents_es_total: action?.talents_es_total}
        }

        case GET_TALENTS_ES_RESET: {
            return {...state, talents_es: [], paginator: {
                    currentPage: 1,
                    lastPage: 1,
                    total: 0
                } , paginatorCount: {
                    currentPage: 1,
                    lastPage: 1,
                    total: 0
                }, talents_es_total: 0}
        }

        case STORE_TALENT_RATING: {
            return {...state, ratings: action?.data}
        }

        case GET_TALENTS_ES_RESET_PAGE: {
            return {...state, page_reset: state.page_reset + 1, talents_es_total: 0}
        }

        case GET_TALENTS_COUNT: {
            return {...state, paginatorCountLoading: true}
        }

        case GET_TALENTS_COUNT_SUCCESS: {
            return {...state, paginatorCount: action?.data?.talents?.paginatorInfo, paginatorCountLoading: false}
        }

        case UPDATE_TALENT_SUCCESS: {
            return {...state, talent: action?.data?.upsertTalent || state.talent}
        }

        case PRESENTATION_TALENT_SUCCESS: {
            return {...state, presentation: action?.data?.presentation || state.presentation}
        }

        case UPDATE_SEMI_PROFILE_SUCCESS: {
            return {...state, semi_profile: action?.data || state.semi_profile}
        }

        case UPDATE_SEMI_PROFILE_ERROR: {
            const newState = {...state, semi_profile_error: action?.payload};
            return newState;
        }

        case CLEAR_SEMI_PROFILE_ERROR: {
            return {...state, semi_profile_error: null};
        }

        case SALARY_DETAILS_SUCCESS: {
            return {...state, salary_details: action?.data || state.salary_details}
        }

        case SALARY_TAX_DETAILS_SUCCESS: {
            return {...state, salary_tax_details: action?.data || state.salary_tax_details}
        }

        case REFETCH_TALENT: {
            return {...state, reupdate_talent: state.reupdate_talent + 1}
        }

        case UPDATE_PROFILE_STATUS_SUCCESS: {
            return {...state, reupdate_talent: state.reupdate_talent + 1}
        }

        case DELETE_TALENT_MULTIPLE_SUCCESS: {
            return {...state, reupdate_talent: state.reupdate_talent + 1}
        }

        case UPDATE_TALENT_MULTIPLE_SUCCESS: {
            return {...state, reupdate_talent: state.reupdate_talent + 1}
        }

        case UPDATE_TALENT_MULTIPLE_LEVEL_SUCCESS: {
            return {...state, reupdate_talent: state.reupdate_talent + 1}
        }

        case UPDATE_EDU_EXP_CERT_SUCCESS: {
            let talentCopy = {...state.talent}
            talentCopy.educations = action?.data?.educations
            talentCopy.experiences = action?.data?.experiences
            talentCopy.certifications = action?.data?.certifications

            return {...state, talent: talentCopy}
        }

        case SKILL_LANG_HOBBY: {
            let talentCopy = {...state.talent}
            if (action?.data?.table === 'skills') {
                let exists = false;
                for (let i = 0; i < talentCopy?.skills?.length; i++) {
                    if (talentCopy.skills[i].name === action?.data?.element?.name) {
                        exists = true;
                    }
                }
                if (!exists) {
                    talentCopy.skills.push(action?.data?.element)
                }
            }
            if (action?.data?.table === 'skills_level') {
                talentCopy.skills[action?.data?.index] = action?.data?.element;
            }
            if (action?.data?.table === 'skills_delete') {
                talentCopy.skills.splice(action?.data?.index, 1);
            }

            /* Languages*/
            if (action?.data?.table === 'hobbies') {
                let exists = false;
                for (let i = 0; i < talentCopy?.hobbies?.length; i++) {
                    if (talentCopy.hobbies[i].name === action?.data?.element?.name) {
                        exists = true;
                    }

                    //do not add empty elements
                    if (!action?.data?.element?.name) {
                        exists = true;
                    }
                }
                if (!exists) {
                    talentCopy.hobbies.push(action?.data?.element)
                }
            }
            if (action?.data?.table === 'hobbies_level') {
                talentCopy.hobbies[action?.data?.index] = action?.data?.element;
            }
            if (action?.data?.table === 'hobbies_delete') {
                talentCopy.hobbies.splice(action?.data?.index, 1);
            }

            /* Languages*/
            if (action?.data?.table === 'languages') {
                let exists = false;
                for (let i = 0; i < talentCopy?.languages?.length; i++) {
                    if (talentCopy.languages[i].code === action?.data?.element?.code) {
                        exists = true;
                    }

                    //do not add empty elements
                    if (!action?.data?.element?.code) {
                        exists = true;
                    }
                }
                if (!exists) {
                    talentCopy.languages.push(action?.data?.element)
                }
            }
            if (action?.data?.table === 'languages_level') {
                talentCopy.languages[action?.data?.index] = action?.data?.element;
            }
            if (action?.data?.table === 'languages_delete') {
                talentCopy.languages.splice(action?.data?.index, 1);
            }

            return {...state, talent: talentCopy, changed_skill_lang_hobby: true}
        }

        case UPDATE_SKILL_LANG_HOBBY_SUCCESS: {
            let talentCopy = {...state.talent}

            return {...state, talent: talentCopy, changed_skill_lang_hobby: false}
        }

        case SET_TALENT_STATE: {
            let talentCopy = {...state.talent}
            talentCopy[action?.payload?.key] = action?.payload?.value

            return {...state, talent: talentCopy}
        }

        case GET_TIMESHEETS_SUCCESS: {
            return {...state, timesheets: action.data.timesheetByTalentId.data}
        }

        case UPSERT_TIMESHEETS_SUCCESS: {
            return {...state, timesheets: action.data}
        }

        case GET_EXPENSE_REPORTS_SUCCESS: {
            return {...state, expense_reports: action.data.expenseReportByTalentId.data}
        }

        case UPSERT_EXPENSE_REPORTS_SUCCESS: {
            return {...state, expense_reports: action.data}
        }

        case DELETE_EXPENSE_REPORTS_SUCCESS: {
            return {...state, expense_reports: action.data}
        }

        case GET_CONTRACTOR_INVOICE_SUCCESS: {
            return {...state, contractor_invoices: action.data.contractorInvoicesByTalentId.data}
        }

        case UPSERT_CONTRACTOR_INVOICE_SUCCESS: {
            return {...state, contractor_invoice_single: action.data}
        }

        case GET_HOLIDAYS_SUCCESS: {
            return {...state, holidays: action.data.talentHolidaysByTalentId.data}
        }

        case UPSERT_HOLIDAYS_SUCCESS: {
            return {...state, holidays: action.data}
        }

        case GET_BONUS_SUCCESS: {
            return {...state, bonus: action.data.talentBonusByTalentId.data}
        }

        case UPSERT_BONUS_SUCCESS: {
            return {...state, bonus: action.data}
        }

        case UPSERT_SURVEY_SUCCESS: {
            return {...state, survey: action.data}
        }

        case GET_CONTRACTOR_INVOICE_EXPLAIN_SUCCESS: {
            return {...state, invoice_explain: action.data}
        }

        case UPSERT_CONTRACTOR_INVOICE_VALIDATION_ERROR: {
            return {...state, validation_error_date: action.data.date}
        }

        case UPDATE_TALENT_BANKING_SUCCESS: {
            return {...state, talent_banking: action.data.banking}
        }

        case GET_TALENT_EMPLOYMENT_SUCCESS: {
            return {...state, talent_employment: action.data}
        }

        case GET_TALENT_HOLIDAYS:
            return { ...state, talent_holidays_loading: true, talent_holidays_error: null };
            
        case GET_TALENT_HOLIDAYS_SUCCESS:
            return { 
                ...state, 
                talent_holidays_loading: false, 
                talent_holidays: action.data 
            };
            
        case GET_TALENT_HOLIDAYS_FAILURE:
            return { 
                ...state, 
                talent_holidays_loading: false, 
                talent_holidays_error: action.payload 
            };

        case GET_TALENT_PORTFOLIO: {
            return {...state, talent_portfolio_loading: true, talent_portfolio_error: null}
        }

        case GET_TALENT_PORTFOLIO_SUCCESS: {
            return {...state, talent_portfolio: action.data, talent_portfolio_loading: false}
        }

        case GET_TALENT_PORTFOLIO_FAILURE: {
            return {...state, talent_portfolio_error: action.error, talent_portfolio_loading: false}
        }

        case CREATE_PORTFOLIO: {
            return {...state, portfolio_create_loading: true, portfolio_create_error: null, portfolio_create_success: false}
        }

        case CREATE_PORTFOLIO_SUCCESS: {
            const updatedPortfolio = state.talent_portfolio ? {
                ...state.talent_portfolio,
                data: [...state.talent_portfolio.data, action.data]
            } : {
                data: [action.data]
            }
            return {
                ...state,
                talent_portfolio: updatedPortfolio,
                portfolio_create_loading: false,
                portfolio_create_success: true
            }
        }

        case CREATE_PORTFOLIO_FAILURE: {
            return {
                ...state,
                portfolio_create_error: action.error,
                portfolio_create_loading: false,
                portfolio_create_success: false
            }
        }

        case DELETE_PORTFOLIO: {
            return {...state}
        }

        case DELETE_PORTFOLIO_SUCCESS: {
            const updatedPortfolio = state.talent_portfolio ? {
                ...state.talent_portfolio,
                data: state.talent_portfolio.data.filter(item => item.id !== action.id)
            } : null
            return {
                ...state,
                talent_portfolio: updatedPortfolio
            }
        }

        case DELETE_PORTFOLIO_FAILURE: {
            return {...state}
        }

        case UPSERT_TALENT_AVAILABILITY_SUCCESS: {
            return {
                ...state,
                availability_update_count: state.availability_update_count + 1,
                availability_data: action.payload
            }
        }

        default:
            return state
    }
}
